import { Link } from "react-router-dom";

function Articles(props) {
  const fetchArticles = props.data.data.content.articles;
  const fetchCategories = props.data.data.content.categories;
  console.log(fetchArticles);
  console.log(fetchCategories);
  return (
    <div>
      <h2>{props.title}</h2>
      <div className="subheading">{props.subtitle}</div>
      <ul className="listArticles">
        {props.featured
          ? fetchArticles
              .filter((post, index) => post.featured == true)
              .filter((post, index) => index < props.limit)
              .map((post) => (
                <li key={post.id}>
                  <Link to={`/article/${post.url}/${post.id}`}>
                    {post.question}
                  </Link>
                  {props.showCategory ? (
                    <span
                      className="badge"
                      style={{
                        backgroundColor: `${
                          fetchCategories[post.categoryId].color
                        }`,
                      }}
                    >
                      {fetchCategories[post.categoryId].title}
                    </span>
                  ) : (
                    ""
                  )}
                </li>
              ))
          : fetchArticles
              .filter((post, index) => post.featured == true)
              .filter((post, index) => index < props.limit)
              .map((post) => (
                <li key={post.id}>
                  <Link to={`/article/${post.url}/${post.id}`}>
                    {post.question}
                  </Link>
                  {props.showCategory ? (
                    <span
                      className="badge"
                      style={{
                        backgroundColor: `${
                          fetchCategories[post.categoryId].color
                        }`,
                      }}
                    >
                      {fetchCategories[post.categoryId].title}
                    </span>
                  ) : (
                    ""
                  )}
                </li>
              ))}
      </ul>
    </div>
  );
}

export default Articles;
